import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import { WebsiteHeaderLayout_FullWidth } from '../../../../hooks/useWebsiteHeaderSettings';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import PageOrScreenWidthImage from '../components/PageOrScreenWidthImage/PageOrScreenWidthImage';

interface FullWidthLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_FullWidth;
  showPlaceholder?: boolean;
}

export const FullWidthLayout = (props: FullWidthLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <PageOrScreenWidthImage
          variant="screen"
          photoDetails={websiteHeader.headerPhoto}
          showPlaceholder={showPlaceholder}
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
